<script>
    import { customer } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/customer.js?1733898724904';
    import md5 from 'js-md5';
    import { onMount } from 'svelte';
    import { append_loaded_categories_to_ga4_item, load_categories, process_ga4_item } from '/srv/web/wyvr/html/releases/58819/gen/client/vendor/googletagmanager/ga4.js?1733898724904';
    import { get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724904';
    import { get_attribute_name } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724904';
    import { get_price_request } from '/srv/web/wyvr/html/releases/58819/gen/client/price_request/get_price_request.js?1733898724904';
    import { load_product } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/api-client/product/load_product.js?1733898724904';
    import { logger, get_error_message } from '@wyvr/generator/universal.js';

    wyvr: {
        render: 'hydrate';
        loading: 'instant';
    }

    ;

    let visitor = null;
    let visitorHash = null;

    if (true) {
        customer?.subscribe((customer) => {
            // load visitor and hash
            if (visitor == null) {
                if (localStorage.getItem('visitor')) {
                    visitor = localStorage.getItem('visitor');
                }
                if (localStorage.getItem('visitor_hash')) {
                    visitorHash = localStorage.getItem('visitor_hash');
                }
            }

            const email = customer?.email ?? null;

            // update the stored values for visitor and hash if the value has changed
            if (visitor !== email) {
                visitor = email;
                visitorHash = visitor ? md5(visitor) : null;
                localStorage.setItem('visitor', visitor);
                localStorage.setItem('visitor_hash', visitorHash);
            }

            gtag({
                visitor,
                visitorHash
            });
        });
    }

    onMount(() => {
        on('wishlist.add', async (product) => {
            if (!product) {
                return;
            }
            const price = get_price_request(product) ? undefined : get_attribute_value(product, 'final_price') || get_attribute_value(product, 'price');
            const item = await process_ga4_item(product, 1);
            if (item) {
                gtag('event', 'add_to_wishlist', {
                    ecommerce: {
                        currency: getStack('currency'),
                        value: price,
                        items: [item]
                    }
                });
            }
        });

        on('cart.add', cart_event);
        on('cart.delete', cart_event);
        on('cart.update', cart_event);
        on('paging.products', async (list) => {
            const category_ids = new Set();
            // build the basic
            const items_list = (
                await Promise.all(
                    list.map(async (product) => {
                        const item = await process_ga4_item(product, 1, false);
                        item.category_ids =
                            get_attribute_value(product, 'category_ids')?.map((id) => {
                                category_ids.add(id);
                                return id;
                            }) ?? [];
                        return item;
                    })
                )
            ).filter(Boolean);
            const list_element = document.querySelector('[data-list-name]');
            let item_list_name = document.title;
            if (list_element) {
                item_list_name = list_element.getAttribute('data-list-name') ?? item_list_name;
            }
            // load the categories
            let categories = [];
            if (category_ids.size > 0) {
                try {
                    // load the categories
                    categories = await load_categories(Array.from(category_ids));
                } catch (e) {
                    logger.error(get_error_message(e));
                }
            }

            // replace the categories
            let items = items_list.map((item) => {
                if (item_list_name) {
                    item.item_list_name = item_list_name;
                }
                return item;
            });
            if (Array.isArray(categories)) {
                items = items_list.map((item) => {
                    const cats = categories.filter((category) => item.category_ids.indexOf(category.entity_id) > -1);
                    item.category_ids = undefined;
                    append_loaded_categories_to_ga4_item(item, cats);
                    return item;
                });
            }

            gtag('event', 'view_item_list', {
                ecommerce: {
                    item_list_id: getStack('scope'),
                    item_list_name,
                    items
                }
            });
        });
    });

    async function cart_event({ item: product, qty, prev_qty }) {
        let changed_qty = qty - prev_qty;
        if (typeof prev_qty === 'undefined') {
            changed_qty = 1;
        }
        // force possitive values
        if (changed_qty < 0) {
            changed_qty *= -1;
        }
        const event = prev_qty === undefined || qty > prev_qty ? 'add_to_cart' : 'remove_from_cart';
        const price = Number.parseFloat(`${get_attribute_name(product, 'final_price') || get_attribute_name(product, 'price')}`);
        let value = undefined;
        if (!Number.isNaN(price)) {
            value = price * changed_qty;
        }

        // load the product
        const [product_error, loaded_product] = await load_product(get_attribute_value(product, 'sku'));

        const item = await process_ga4_item(loaded_product ?? product, 1);
        if (item) {
            gtag('event', event, {
                ecommerce: {
                    currency: getStack('currency'),
                    value,
                    items: [item]
                }
            });
        }
    }
</script>

<div class="datalayer" />
